module.exports = __webpack_public_path__ + "media/images/lp/lp19-08915994790e45faffb13d448a12fd26.webp";